import React, { useState, useRef, useEffect } from 'react';
import { useCart } from 'react-use-cart';
import { Icon } from '@iconify/react';
import Cart from '@iconify/icons-mdi/cart';

import Dropdown from '~/components/modules/cards/products/dropdown';
import Button from '~/components/modules/buttons/default';
import OrderableItemsForm from '~/components/modules/forms/orderable-items';

import useClickOutside from '~/hooks/useClickOutside';

const Mode = Object.freeze({
	EMPTY: 'Empty',
	ORDER: 'Order',
	IN_CART: 'In Cart',
	UPDATED: 'Updated'
});

const OrderButton = ({ item }) => {
	const [mode, setMode] = useState(Mode.EMPTY);
	const [quantity, setQuantity] = useState(Mode.EMPTY);

	const dropdownRef = useRef();
	const { inCart, getItem } = useCart();

	useClickOutside(dropdownRef, () => {
		setMode(Mode.EMPTY);
	});

	const handleOnComplete = () => {
		setMode(Mode.UPDATED);
		setTimeout(() => {
			setMode(Mode.EMPTY);
		}, 2000);
	};

	useEffect(() => {
		let sum = 0;
		item.Availability?.forEach(availability => {
			if (inCart(availability.recordId)) {
				const cartItem = getItem(availability.recordId);
				sum += cartItem.quantity;
			}
		});
		setQuantity(sum);

		if (mode === mode.EMPTY && sum !== 0) {
			setMode(Mode.IN_CART);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [mode]);

	return (
		<Dropdown
			forwardRef={dropdownRef}
			isOpen={mode === Mode.ORDER}
			button={
				<Button
					as="button"
					variant="secondary"
					size="sm"
					className={`
						w-full flex items-center justify-between !text-2xs
						${mode === Mode.ORDER ? '!bg-gray-300 text-gray-500' : ''}
					`}
					onClick={() => setMode(mode !== Mode.ORDER ? Mode.ORDER : Mode.EMPTY)}
				>
					<span className="flex-1 text-left">
						{mode === Mode.EMPTY &&
							(quantity === 0 ? Mode.ORDER : `${Mode.IN_CART}: ${quantity}`)}
						{mode === Mode.IN_CART && `${Mode.IN_CART}: ${quantity}`}
						{mode === Mode.ORDER &&
							(quantity === 0 ? Mode.ORDER : `${Mode.IN_CART}: ${quantity}`)}
						{mode === Mode.UPDATED && `${Mode.UPDATED}!`}
					</span>

					{mode === Mode.UPDATED ? (
						<CheckMark />
					) : (
						<Icon icon={Cart} height="1rem" width="1rem" className="w-3 h-3" />
					)}
				</Button>
			}
		>
			<OrderableItemsForm item={item} onComplete={handleOnComplete} />
		</Dropdown>
	);
};

export const CheckMark = () => (
	<svg
		viewBox="0 0 120 120"
		className="inline-block w-4 h-4 animate-added-to-cart"
	>
		<circle
			className="animate-added-to-cart-circle stroke-current stroke-[8] fill-transparent transition-all [stroke-dasharray:360] [stroke-linecap:round] origin-center rotate-180"
			cx="60"
			cy="60"
			r="52"
		/>
		<path
			d="M10.05304,50.05005L30.133842,70.037099L75.05304,25.05005"
			className="animate-added-to-cart-check fill-transparent stroke-current stroke-[12] [stroke-dasharray:100] [stroke-linecap:round] translate-x-[11%] translate-y-[11%] scale-75 origin-center"
		/>
	</svg>
);

export default OrderButton;
